module.exports = __webpack_public_path__ + "static/media/expo2020.78ed283b.jpeg";